export type PermissionGroupKeys = 'admin' | 'standard' | 'strict' | 'custom';

export enum WorkspacePermissions {
  CanManageSettings = 'canManageSettings',
  CanManageBilling = 'canManageBilling',
  CanManageTeam = 'canManageTeam',
}

export enum ProjectPermissions {
  CanViewAll = 'canViewAll',
  CanManageGroups = 'canManageGroups',
  CanModify = 'canModify',
  CanPublish = 'canPublish',
  CanArchive = 'canArchive',
}

export enum StatsPermissions {
  CanView = 'canView',
}

export enum ZapcodesPermissions {
  CanAllocate = 'canAllocate',
}

export enum ZapvisionPermissions {
  CanViewAll = 'canViewAll',
  CanModify = 'canModify',
  CanArchive = 'canArchive',
  CanPublish = 'canPublish',
}

export enum ZmlPermissions {
  CanAssignLabels = 'canAssignLabels',
  CanChangeStatus = 'canChangeStatus',
  CanDeleteAsset = 'canDeleteAsset',
  CanEditLabels = 'canEditLabels',
  CanPublish = 'canPublish',
  CanUploadVersion = 'canUploadVersion',
}

export interface WorkspaceUserPermissions {
  workspace?: Partial<Record<WorkspacePermissions, boolean>>
  projects?: Partial<Record<ProjectPermissions, boolean>>
  stats?: Partial<Record<StatsPermissions, boolean>>
  zapcodes?: Partial<Record<ZapcodesPermissions, boolean>>
  zapvision?: Partial<Record<ZapvisionPermissions, boolean>>
  zml?: Partial<Record<ZmlPermissions, boolean>>
}

export interface WorkspaceUserPermissionsPayload {
  workspace?: WorkspacePermissions[]
  projects?: ProjectPermissions[]
  stats?: StatsPermissions[]
  zapcodes?: ZapcodesPermissions[]
  zapvision?: ZapvisionPermissions[]
  zml?: ZmlPermissions[]
}
